const getters = {
  countries (state) {
    return state.countries
  },

  communication_methods (state) {
    return state.communication_methods
  },

  account (state) {
    return state.account
  },

  accounts (state) {
    return state.member_accounts
  },
  subAccountInvitePopup (state) {
    return state.popup
  },
  createAccountPopup (state) {
    return state.create_account_popup
  },

  managers (state) {
    return state.managers
  },

  acceptedAccounts (state) {
    return state.acceptedAccounts
  }
}

export default getters
